type DefaultCategoryHashtagsType = {
  [key: string]: string[];
};

export const shareSettings = {

}

export const defaultNewsHashags = ["CHEWY", "Shibarium", "Dogechain"];

export const defaultCategoryHashTags: DefaultCategoryHashtagsType = {
    "crypto-news": ["CryptoNews", "Web3", "DeFi"],
    "chewy-updates": ["CHEWY", "SHIBARIUM", "DOGECHAIN"],
};
